import api from './apiHelper';

const BOOKING_ROUTE = '/booking';

/* ============================================= basic function ============================================ */
// ============================================= POST CREATE
export const postCreateBooking = payload => {
  return api.post(`${BOOKING_ROUTE}`, payload);
};
